// extracted by mini-css-extract-plugin
export default {"selectTemplateContainer":"_2B-eLg5WxmrAwDGYY1urHo","editTemplateLinkContainer":"_1oQGw1xri8siLyMhFomt6Y"};